import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getReportedPendingCount } from "../controller";
import { requestHandler } from "../helper";

function Sidebar({ isCollapsed, setIsCollapsed }) {

    const location = useLocation();
    const [pendingReports, setPendingReports] = useState(0);

    // Pending reported content: recount on page change and when an admin action asks for it
    useEffect(() => {
        const load = () => requestHandler(
            async () => await getReportedPendingCount(),
            null,
            (res) => setPendingReports(res.data?.total || 0),
            () => { }
        );
        load();
        window.addEventListener('reported-count-refresh', load);
        return () => window.removeEventListener('reported-count-refresh', load);
    }, [location.pathname]);


    // useEffect(() => {
    //     const allowedPaths = ["/event-management", "/event-management/edit"];

    //     const isAllowed = allowedPaths.some(path =>
    //         location.pathname.startsWith(path)
    //     );

    //     if (!isAllowed) {
    //         localStorage.removeItem("activeEventTab");
    //     }
    // }, [location.pathname]);

    const sidebarItems = [
        { to: '/dashboard', icon: '/images/svg/dashboard.svg', label: 'Dashboard' },
        { to: '/user-management', icon: '/images/svg/user-management.svg', label: 'User Management' },
        { to: '/activity-management', icon: '/images/svg/activity-management.svg', label: 'Reported Content' },
        { to: '/activity-images', icon: '/images/svg/activity-images.svg', label: 'Activity Images' },
        {
            to: '/marketplace-management', icon: '/images/svg/marketplace-management.svg', label: 'Marketplace Management',
            subItems: [
                { to: '/event-details', icon: '/images/svg/event-details.svg', label: 'Event Details' },
            ]
        },
        { to: '/category-management', icon: '/images/svg/event-management.svg', label: 'Category Management' },
        { to: '/notification-management', icon: '/images/svg/notification-management.svg', label: 'Notification Management' },
        { to: '/feedback-support', icon: '/images/svg/feedback-support.svg', label: 'Feedback & Support Module' },
        { to: '/privacy-policy-admin', icon: '/images/svg/privacy-policy.svg', label: 'Privacy Policy' },
        { to: '/app-version', icon: '/images/svg/app-version.svg', label: 'App Version' },
    ];



    const isActive = (path) => {
        if (path === '/marketplace-management' && (location.pathname.startsWith('/marketplace-management') || location.pathname === '/event-details')) {
            return true;
        } else {
            return location.pathname.startsWith(path);
        }
    };



    const handleCloseSidebar = () => {
        setIsCollapsed(false);
    };

    return (
        <div className={`sidebar-wrapper ${isCollapsed ? 'show' : ''}`}>
            <div className='close-sidebar d-lg-none' onClick={handleCloseSidebar}>
                <img src="/images/svg/close.svg" alt="icon" />
            </div>
            <div className="logo-wrapper">
                <Link to="/">
                    <img src="/images/svg/logo.svg" alt="logo" />
                </Link>
            </div>
            <ul className="sidebar-menu theme-scrollbar">
                {sidebarItems.map((item, index) => (
                    <li key={index}>
                        <Link
                            to={item.to || (item.subItems && item.subItems[0].to)}
                            className={isActive(item.to || (item.subItems && item.subItems[0].to)) ? 'active' : ''}
                        >
                            <img src={item.icon} alt="icon" />
                            {item.label}
                            {item.to === '/activity-management' && pendingReports > 0 && (
                                <span className="sidebar-badge" title="Pending reports">{pendingReports > 99 ? '99+' : pendingReports}</span>
                            )}
                        </Link>
                        {/* Handle Sub-Items */}
                        {/* {item.subItems && (
                            <ul className="sub-menu">
                                {item.subItems.map((subItem, subIndex) => (
                                    <li key={subIndex}>
                                        <Link
                                            to={subItem.to}
                                            className={isActive(subItem.to) ? 'active' : ''}
                                        >
                                            <img src={subItem.icon} alt="icon" />
                                            {subItem.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        )} */}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Sidebar;
